<form *ngIf="tighteningFormGroup" [formGroup]="tighteningFormGroup" (ngSubmit)="btnCtpConfirmClicked()">
    <app-tightening-method [enable]="enable" [form]="tighteningFormGroup" [calculationType]="calculationType"></app-tightening-method>
    <!-- <br /> -->

    <ng-container *ngIf="tighteningFormGroup.get('calcMethod').value == 'Tension'">
        <app-percentage-cover [enable]="enable" [form]="tighteningFormGroup"></app-percentage-cover>
    </ng-container>
    <!-- <br /> -->

    <app-lubricant [form]="tighteningFormGroup" [enable]="enable"></app-lubricant>

    <div class="" *ngIf="idmsSharedService.enableConfirmWithRouter(1)">
        <a href="javascript:void(0)" class="btn font-weight-bold py-3 px-6 secondary-ebtn informateFullWidth" (click)="btnCtpConfirmClicked()">
            <!-- Confirm -->
            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CONFIRM' | transloco }}
        </a>
    </div>
</form>
